module.exports = __webpack_public_path__ + "img/vps2.baef64f.png";